module.exports = __webpack_public_path__ + "asset/image-ic_category_33-dc6acb33c72d3087.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_33.svg
// module id = zsci
// module chunks = 0